import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { UserContext } from '../context';


const UserContextRoute = ({ component: Component, activeCampaign, ...rest }) => {
  const user = React.useContext(UserContext);
  const nakedNewsDomain = window.location.hostname.includes('nakednews');
  if (!user.authenticated && !nakedNewsDomain) {
    return <Redirect to={{ pathname: '/tour' }} />;
  }

  return (
    <Route
      {...rest}
      render={(props) => (
        <Component
          {...props}
          activeCampaign={activeCampaign || {}}
          user={user}
        />
      )}
    />
  );
};

export default UserContextRoute;
